<template>
    <div>
        <Item :name="name" :icon="icon" :linkUrl="linkUrl" />
        <slot />
    </div>
</template>

<script>
import Item from './Item'

export default {
    components: { Item },
    props: {
        name: { type: String, required: true },
        icon: { type: String },
        linkUrl: { type: String, required: false, }
    }    
}
</script>